// src/pages/Messages.js
// Messagerie client : discussions avec les marchands
// Maxula
import React from 'react';
import ChatView from '../components/chat/ChatView';

const Messages = () => (
  <div className="max-w-5xl mx-auto px-4 py-8">
    <h1 className="text-2xl font-bold text-gray-900 mb-4">Mes messages</h1>
    <ChatView as="customer" />
  </div>
);

export default Messages;
